<script setup lang="ts">
import type { Image } from 'sanity';
import type { PortableTextComponentProps } from '@portabletext/vue';

// See: https://sanity.nuxtjs.org/helpers/images#using-sanityimage-url

const props = defineProps<PortableTextComponentProps<Image & { alt?: string, alignment?: string }>>();
</script>

<template>
  <div class="block__image inline-block" :class="props.value.alignment !== 'default' ? ' flex justify-center'  : ''"  >
    <BaseImage :image="props.value" />
  </div>
</template>

